const FeaturesSectionV4 = () => {
  const features = [{
    title: "Your AI Buddy That Never Forgets",
    description: "Remembers every PACT, learns your patterns, suggests what actually works for you.",
    icon: <svg className="w-12 h-12" viewBox="0 0 64 64" fill="none">
          <circle cx="32" cy="24" r="16" stroke="currentColor" strokeWidth="3" className="text-blue-500" />
          <circle cx="28" cy="20" r="2" fill="currentColor" className="text-blue-500" />
          <circle cx="36" cy="20" r="2" fill="currentColor" className="text-blue-500" />
          <path d="M26 28c2 2 4 2 6 2s4 0 6-2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" className="text-blue-500" />
          <path d="M16 48l8-8h16l8 8" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="text-blue-500" />
          <circle cx="20" cy="12" r="3" fill="currentColor" className="text-yellow-400" />
          <circle cx="44" cy="16" r="2" fill="currentColor" className="text-green-400" />
          <circle cx="48" cy="32" r="2" fill="currentColor" className="text-purple-400" />
        </svg>,
    mockup: <div className="bg-white rounded-2xl p-4 shadow-lg">
          <div className="text-center mb-4">
            <div className="w-12 h-12 bg-blue-500 rounded-full mx-auto mb-2 flex items-center justify-center">
              <span className="text-white font-bold">AI</span>
            </div>
            <p className="text-sm font-medium text-gray-600">Smart Suggestions</p>
          </div>
          <div className="space-y-2">
            <div className="bg-blue-50 rounded-lg p-2">
              <p className="text-xs font-medium text-blue-700">💡 Based on your patterns, try "Read 5 pages for 14 days"</p>
            </div>
            <div className="bg-green-50 rounded-lg p-2">
              <p className="text-xs font-medium text-green-700">✨ You show up best on weekdays</p>
            </div>
          </div>
        </div>,
    rotation: 'rotate-1'
  }, {
    title: "Just Tell Me What You're Struggling With",
    description: "Feeling unmotivated? Just speak to Show Up! Get personalized PACT suggestions instantly.",
    icon: <svg className="w-12 h-12" viewBox="0 0 64 64" fill="none">
          <circle cx="32" cy="32" r="20" stroke="currentColor" strokeWidth="3" className="text-green-500" />
          <circle cx="32" cy="32" r="12" fill="currentColor" className="text-green-500" />
          <circle cx="32" cy="32" r="6" fill="white" />
          <path d="M20 20c2-2 4-2 6-2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" className="text-green-400" />
          <path d="M38 18c2 0 4 0 6 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" className="text-green-400" />
          <path d="M44 38c0 2-2 4-2 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" className="text-green-400" />
        </svg>,
    mockup: <div className="bg-white rounded-2xl p-4 shadow-lg">
          <div className="text-center mb-4">
            <div className="w-12 h-12 bg-green-500 rounded-full mx-auto mb-2 flex items-center justify-center animate-pulse">
              <span className="text-white text-xl">🎤</span>
            </div>
            <p className="text-sm font-medium text-gray-600">Voice Input Active</p>
          </div>
          <div className="bg-gray-50 rounded-lg p-3">
            <p className="text-xs text-gray-700 italic">"I want to read more but I'm always tired after work..."</p>
          </div>
          <div className="mt-2 bg-green-50 rounded-lg p-2">
            <p className="text-xs font-medium text-green-700">💡 Try: "Read 1 page for 7 days"</p>
          </div>
        </div>,
    rotation: '-rotate-2'
  }, {
    title: "Your Daily Buddy Who Actually Gets It",
    description: "Gentle daily encouragement. Not pushy reminders—just a friend saying 'You've got this.'",
    icon: <svg className="w-12 h-12" viewBox="0 0 64 64" fill="none">
          <circle cx="32" cy="28" r="16" stroke="currentColor" strokeWidth="3" className="text-orange-500" />
          <circle cx="28" cy="24" r="2" fill="currentColor" className="text-orange-500" />
          <circle cx="36" cy="24" r="2" fill="currentColor" className="text-orange-500" />
          <path d="M26 32c2 4 4 4 6 4s4 0 6-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" className="text-orange-500" />
          <path d="M16 52c4-4 8-4 16-4s12 0 16 4" stroke="currentColor" strokeWidth="3" strokeLinecap="round" className="text-orange-500" />
          <circle cx="20" cy="16" r="2" fill="currentColor" className="text-yellow-400" />
          <circle cx="44" cy="20" r="2" fill="currentColor" className="text-pink-400" />
        </svg>,
    mockup: <div className="bg-white rounded-2xl p-4 shadow-lg">
          <div className="text-center mb-4">
            <div className="w-12 h-12 bg-orange-500 rounded-full mx-auto mb-2 flex items-center justify-center">
              <span className="text-white text-xl">😊</span>
            </div>
            <p className="text-sm font-medium text-gray-600">Daily Check-in</p>
          </div>
          <div className="bg-orange-50 rounded-lg p-3 text-center">
            <p className="text-sm font-medium text-orange-700 mb-2">Hey! Ready for today?</p>
            <p className="text-xs text-orange-600">You've shown up 5 days straight. That's amazing! 🌟</p>
          </div>
        </div>,
    rotation: 'rotate-1'
  }, {
    title: "Know Yourself Better Than Ever",
    description: "Discover when you're most likely to show up and what motivates you most.",
    icon: <svg className="w-12 h-12" viewBox="0 0 64 64" fill="none">
          <rect x="8" y="16" width="48" height="32" rx="4" stroke="currentColor" strokeWidth="3" className="text-purple-500" />
          <path d="M16 40l6-8 6 4 8-12 6 8 6-4" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="text-purple-500" />
          <circle cx="22" cy="32" r="2" fill="currentColor" className="text-yellow-400" />
          <circle cx="42" cy="28" r="2" fill="currentColor" className="text-green-400" />
        </svg>,
    mockup: <div className="bg-white rounded-2xl p-4 shadow-lg">
          <div className="text-center mb-4">
            <div className="w-12 h-12 bg-purple-500 rounded-full mx-auto mb-2 flex items-center justify-center">
              <span className="text-white text-xl">📊</span>
            </div>
            <p className="text-sm font-medium text-gray-600">Weekly Insights</p>
          </div>
          <div className="space-y-2">
            <div className="bg-purple-50 rounded-lg p-2">
              <p className="text-xs font-medium text-purple-700">🌅 You show up best at 7am</p>
            </div>
            <div className="bg-blue-50 rounded-lg p-2">
              <p className="text-xs font-medium text-blue-700">📈 85% success rate this week</p>
            </div>
          </div>
        </div>,
    rotation: '-rotate-1'
  }, {
    title: "Celebrate Every Single Show Up",
    description: "No shame for missed days. Just genuine celebration for every time you show up.",
    icon: <svg className="w-12 h-12" viewBox="0 0 64 64" fill="none">
          <path d="M32 8l4 12h12l-10 8 4 12-10-8-10 8 4-12-10-8h12z" stroke="currentColor" strokeWidth="3" fill="currentColor" className="text-yellow-500" />
          <circle cx="18" cy="18" r="3" fill="currentColor" className="text-pink-400" />
          <circle cx="46" cy="22" r="2" fill="currentColor" className="text-blue-400" />
          <circle cx="50" cy="46" r="2" fill="currentColor" className="text-green-400" />
          <circle cx="14" cy="50" r="2" fill="currentColor" className="text-purple-400" />
        </svg>,
    mockup: <div className="bg-white rounded-2xl p-4 shadow-lg">
          <div className="text-center mb-4">
            <div className="w-12 h-12 bg-yellow-500 rounded-full mx-auto mb-2 flex items-center justify-center animate-bounce">
              <span className="text-white text-xl">🎉</span>
            </div>
            <p className="text-sm font-medium text-gray-600">You Showed Up!</p>
          </div>
          <div className="bg-yellow-50 rounded-lg p-3 text-center">
            <p className="text-lg font-black text-yellow-700 mb-1">Amazing! 🌟</p>
            <p className="text-xs text-yellow-600">Day 8 complete! You're building something special.</p>
          </div>
        </div>,
    rotation: 'rotate-2'
  }, {
    title: "Community Challenges (Coming Soon)",
    description: "Create PACTs with friends. 'Exercise for 30 days with Alex'—shared progress, mutual motivation.",
    icon: <svg className="w-12 h-12" viewBox="0 0 64 64" fill="none">
          <circle cx="24" cy="20" r="8" stroke="currentColor" strokeWidth="3" className="text-teal-500" />
          <circle cx="40" cy="20" r="8" stroke="currentColor" strokeWidth="3" className="text-teal-500" />
          <path d="M16 44c0-4.4 3.6-8 8-8s8 3.6 8 8" stroke="currentColor" strokeWidth="3" className="text-teal-500" />
          <path d="M32 44c0-4.4 3.6-8 8-8s8 3.6 8 8" stroke="currentColor" strokeWidth="3" className="text-teal-500" />
          <path d="M24 28c4 0 8 0 12 0" stroke="currentColor" strokeWidth="2" className="text-teal-400" />
        </svg>,
    mockup: <div className="bg-white rounded-2xl p-4 shadow-lg border-2 border-teal-200">
          <div className="text-center mb-4">
            <div className="w-12 h-12 bg-teal-500 rounded-full mx-auto mb-2 flex items-center justify-center">
              <span className="text-white text-xl">👥</span>
            </div>
            <p className="text-sm font-medium text-teal-600">Community PACT</p>
          </div>
          <div className="bg-teal-50 rounded-lg p-3">
            <p className="text-xs font-bold text-teal-700 mb-1">Exercise with Alex</p>
            <p className="text-xs text-teal-600">Day 12 of 30 • Both completed today! 💪</p>
          </div>
          <div className="mt-2 text-center">
            <span className="bg-teal-100 text-teal-700 text-xs font-bold px-2 py-1 rounded-full">Coming Soon</span>
          </div>
        </div>,
    isComingSoon: true,
    rotation: '-rotate-2'
  }];
  return <section className="py-24 bg-gradient-to-br from-purple-500 via-purple-400 to-indigo-500 relative overflow-hidden">
      {/* Background bubbles */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-10 w-32 h-32 bg-white/10 rounded-full blur-3xl animate-pulse-gentle"></div>
        <div className="absolute bottom-20 right-10 w-40 h-40 bg-yellow-400/20 rounded-full blur-3xl animate-pulse-gentle delay-1000"></div>
        <div className="absolute top-1/2 left-1/3 w-60 h-60 bg-white/5 rounded-full blur-3xl"></div>
      </div>

      <div className="container max-w-7xl mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-black text-white mb-6 tracking-tight">
            Meet your
            <span className="block text-yellow-400 flex items-center justify-center gap-3 md:gap-4">
              daily buddy
              <img alt="Show Up Mascot - Your helpful daily buddy" className="w-12 h-12 md:w-16 md:h-16 drop-shadow-lg hover:scale-110 transition-transform duration-300 animate-bounce-in inline-block" onLoad={() => console.log('✅ Mascot loaded successfully after buddy text')} onError={e => console.error('❌ Error loading mascot after buddy text:', e)} src="/lovable-uploads/8f38dcc6-739f-4386-b225-623543075d5f.png" />
            </span>
          </h2>
          <p className="text-2xl text-white/90 font-medium max-w-4xl mx-auto leading-relaxed">
            These features make Show Up! the app that finally gets it
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {features.map((feature, index) => <div key={index} className={`group relative ${feature.isComingSoon ? 'bg-gradient-to-br from-teal-500/20 to-cyan-500/20 border-teal-400/30' : 'bg-white/10 border-white/20'} backdrop-blur-sm rounded-3xl p-8 border transition-all duration-500 ease-out transform ${feature.rotation} hover:rotate-0 hover:scale-105 hover:shadow-2xl cursor-pointer`}>
              {feature.isComingSoon && <div className="absolute top-4 right-4">
                  <span className="bg-teal-400 text-gray-900 text-xs font-black px-3 py-1 rounded-full">
                    Coming Soon
                  </span>
                </div>}

              <div className="grid md:grid-cols-2 gap-6 items-center">
                {/* Content */}
                <div>
                  <div className="mb-6">
                    <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center mb-4 group-hover:bg-white/30 transition-all duration-300 group-hover:scale-110">
                      {feature.icon}
                    </div>
                    <h3 className="text-2xl font-black text-white mb-3">
                      {feature.title}
                    </h3>
                    <p className="text-lg text-white/90 leading-relaxed font-medium">
                      {feature.description}
                    </p>
                  </div>
                </div>

                {/* Mockup */}
                <div className="flex justify-center">
                  <div className="transform transition-all duration-300 group-hover:scale-105 group-hover:-translate-y-2">
                    {feature.mockup}
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};
export default FeaturesSectionV4;